import React from 'react';
import Icons from '../../../../Components/Icons/Icons';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import ToolTipWrapper from '../../../../hoc/Wrp/ToolTipWrapper';
import Wrp from '../../../../hoc/Wrp/Wrp';
import $ from 'jquery';

const PdfTagList = (props) => {
	const {variableList,toggleVariableModel,htmlContentData,pdfDetails} = props;

  const selectedCount = (e) => {
    let cnt = $('input.fieldChckBox:checked').length;
    $("#dispCnt").text(cnt);
    props.checkIterateColumns(e);
  }
  const addVar = <label className=""> Variable List
          <div className="selectgroup ml-2">
            <div className="selectgroup-item "> <span className="selectgroup-button selectgroup-button-icon primary_bg" onClick={toggleVariableModel}><Icons iconType="AddPlus" />
              </span>
            </div>
          </div>
        </label>;

  let dependentWindowName = '';
  let textToCopy = '';
  if(htmlContentData.drillDownData) {
    if(htmlContentData.drillDownData.length > 0) {
      htmlContentData.drillDownData.map((pArr,pInd) => {
        dependentWindowName +=  dependentWindowName === '' ? pArr.api_name : '.'+pArr.api_name;
      })
      let dependentWindowNameVal = dependentWindowName
      if(htmlContentData.iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')]) {
        if(htmlContentData.iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')].length > 0) {
          htmlContentData.iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')].map((arr,i) => {
            const fieldData = props.getFieldDataUsingId(arr);
            textToCopy += '${'+dependentWindowName+'.'+fieldData.api_name+'} ';  
          })
        }
      }
    }
    if(textToCopy !== '') {
      textToCopy = '<x-'+dependentWindowName.replaceAll('.','-')+'>'+textToCopy+'</x-'+dependentWindowName.replaceAll('.','-')+'>';
    }
  } 

  console.log(pdfDetails);
  //style={{width:'100%'}}
	return(
		<div className="tagListOuter" >
      <div className="form-group">
        {htmlContentData.drillDownData && htmlContentData.drillDownData.length>0?
          <Wrp>
            <ul className="breadcrumbs text-small">
              <li onClick={e=>props.goBackDrillDown(-1)} className="nav-item">
                <a className=""> Variable List </a>
              </li>
              <li className="separator">
                <i className="fas fa-chevron-right fourth_light_color"></i>
              </li>
              {
                htmlContentData.drillDownData.map((item,ind) => {
                  return (
                    <Wrp key={ind}>
                      <li onClick={e=>props.goBackDrillDown(ind)}  className="nav-item">
                        <a className=""> {item.name?item.name:item.variable_name} </a>
                      </li>
                      <li className="separator">
                      <i className="fas fa-chevron-right fourth_light_color"></i>
                      </li>
                    </Wrp>
                  )
                })
              } 
            </ul>
            <div className="d-flex align-items-center justify-content-between"> 
              <label className="pl-0"> 
                <span className="badge badge-warning secondary_color" data-toggle="tooltip" data-placement="top" id="dispCnt" data-title="selected tags">0
                </span>
              </label>
              <div className="pr-2">
                <CopyToClipboard text={ textToCopy }>
                  <i className="fas fa-copy fa-lg text-info mr-1 cursor-pointer" data-tip="Copy"></i>
                </CopyToClipboard>
                
                <i 
                  className="fas fa-file-import fa-lg text-info cursor-pointer" 
                  data-tip="INSERT" 
                  //onClick={e=>props.insertGroupTextHandler(dependentWindowName)}
                  ></i>
              </div>
            </div>
          </Wrp>
        :addVar}
        
        <div className="pr-1 mr-1 tagList">
        {	variableList ?
            variableList.map((arr,i) => {
              return (
                <div key={i} className="clickTag">
                  <div className="crm_custFields third_dark_color mb-1" > 
                    {htmlContentData.drillDownData && htmlContentData.drillDownData.length>0?
                      <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="custom-control-input fieldChckBox" value={arr.id} name={'field_check'+i} id={i+1} onChange={selectedCount}/>
                        <label className="custom-control-label mb-0" htmlFor={i+1}> {arr.name?arr.name:arr.variable_name} </label>
                        </div>
                    :arr.name?arr.name:arr.variable_name}
                  </div>
                  <span className="tagCopy icon-right hide">
                  { arr.fields && arr.fields.length>0 ?
                      <i className="fas fa-arrow-right fa-lg text-info mr-1" data-tip="SUB LIST" onClick={e=>props.drillDownNextLevel(JSON.stringify(arr))}></i>
                    : null }
                    <span onClick={e=>props.variableDeleteHandler(arr.id)}><Icons iconType={"Delete"} size={18} color={'#000'} /></span>
                    <CopyToClipboard text={ dependentWindowName !== '' ? '${'+dependentWindowName+'.'+arr.api_name+'}' : '${'+arr.api_name+'}'} >
                      <i className="fas fa-copy fa-lg text-info mr-1" data-tip="Copy"></i>
                    </CopyToClipboard>
                    <ToolTipWrapper />
                    <i 
                      className="fas fa-file-import fa-lg text-info" 
                      data-tip="Insert" 
                      //onClick={e=>props.insertTextHandler(arr.api_name,'',dependentWindowName)}
                      onClick={e=>props.insertTextHandler(arr.api_name,'',dependentWindowName)}                      
                    ></i>
                  </span>

                </div>
               
              )
            })
          : null
        }
      </div>
      
      </div>
    </div>
	)
}

export default PdfTagList;